import React, { useState, useEffect } from 'react';
import analyticsService from '../services/analyticsService';

const CookieBanner = () => {
  const [isVisible, setIsVisible] = useState(false);

  useEffect(() => {
    // Check if user has already accepted cookies
    const cookieConsent = localStorage.getItem('bullbearly-cookie-consent');
    if (!cookieConsent) {
      setIsVisible(true);
    }
  }, []);

  const handleAccept = () => {
    localStorage.setItem('bullbearly-cookie-consent', JSON.stringify(true));
    setIsVisible(false);
    
    // Initialize analytics if not already done
    if (!analyticsService.isAnalyticsEnabled()) {
      analyticsService.initialize();
    }
    
    // Track cookie acceptance
    analyticsService.trackEvent('cookie_consent', {
      event_category: 'privacy',
      event_label: 'accepted'
    });
  };

  const handleDecline = () => {
    localStorage.setItem('bullbearly-cookie-consent', JSON.stringify(false));
    setIsVisible(false);
    
    // Remove analytics if enabled
    if (analyticsService.isAnalyticsEnabled()) {
      localStorage.removeItem('bullbearly-ga4-measurement-id');
    }
    
    // Track cookie decline
    analyticsService.trackEvent('cookie_consent', {
      event_category: 'privacy',
      event_label: 'declined'
    });
  };

  if (!isVisible) {
    return null;
  }

  return (
    <div className="cookie-banner">
      <div className="cookie-banner-content">
        <div className="cookie-banner-text">
          <h3>🍪 We use cookies</h3>
          <p>
            We use cookies and similar technologies to enhance your experience, analyze site traffic, 
            and personalize content. By clicking "Accept All", you consent to our use of cookies. 
            You can manage your preferences in settings.
          </p>
        </div>
        <div className="cookie-banner-actions">
          <button 
            onClick={handleDecline}
            className="cookie-button cookie-button-decline"
          >
            Decline
          </button>
          <button 
            onClick={handleAccept}
            className="cookie-button cookie-button-accept"
          >
            Accept All
          </button>
        </div>
      </div>
    </div>
  );
};

export default CookieBanner;
